exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-group-btn {\n  position: static; }\n  .input-group-btn .dropdown-toggle {\n    width: 0; }\n    .input-group-btn .dropdown-toggle::after {\n      margin-left: -0.2em; }\n  .input-group-btn > .dropdown-menu {\n    left: 0 !important; }\n\n.dropdown-menu {\n  max-height: 250px;\n  overflow: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/components/editable-select/editable-select.component.scss
// module id = ../../../../../resources/assets/src/app/shared/components/editable-select/editable-select.component.scss
// module chunks = main